// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Invoice: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 69.5 69.5" fill="currentColor">
            <path
                d="M22.6 18.2h17.5c.1 0 .2 0 .3.1l6.8 6.9c.1.1.1.2.1.3v25.3c0 .2-.2.4-.4.4H22.6c-.2 0-.4-.2-.4-.4V18.6c0-.2.2-.3.4-.4zm17 1H23.2v31h23V26.1h-6.3c-.2 0-.4-.2-.4-.4l.1-6.5zm-4.8 4c.4 0 .7.3.7.7v2.2c1.4.1 2.8.4 3.8.6.4.1.6.5.5.9s-.5.6-.9.5c-1.5-.4-3.7-.8-5.6-.6-1 .1-1.8.3-2.4.7-.6.4-1 .9-1.2 1.8-.1.7 0 1.1.1 1.5.2.4.5.7 1 1 1 .6 2.4 1 4.1 1.4h.1c1.5.4 3.2.8 4.4 1.6.6.4 1.1.9 1.5 1.6.3.7.4 1.5.3 2.4-.3 1.5-1.4 2.6-2.8 3.1-.8.3-1.8.5-2.9.5v2.2c0 .4-.3.7-.7.7s-.7-.3-.7-.7v-2.2c-.3-.1-.6-.1-.9-.1-1.2-.2-3-.6-4.5-1.2-.4-.2-.5-.6-.4-.9.2-.4.6-.5.9-.4 1.4.6 3 1 4.1 1.1 1.8.2 3.3.1 4.4-.3 1.1-.4 1.8-1.1 1.9-2.1.1-.7 0-1.1-.1-1.5-.2-.4-.5-.7-1-1-1-.6-2.4-1-4.1-1.4h-.1c-1.5-.4-3.2-.8-4.4-1.6-.6-.4-1.2-.9-1.5-1.6-.3-.7-.4-1.5-.3-2.4.2-1.3.9-2.2 1.8-2.7.9-.6 2-.8 3-.9h.8V24c.3-.4.7-.8 1.1-.8zm5.4-4v6h6l-6-6z"
            />
            <path
                fill="#999"
                d="M34.8 69.5C15.6 69.5 0 53.9 0 34.7S15.6 0 34.8 0s34.8 15.6 34.8 34.7-15.7 34.8-34.8 34.8zm0-68C16.4 1.5 1.5 16.4 1.5 34.7S16.4 68 34.8 68 68 53.1 68 34.7 53.1 1.5 34.8 1.5z"
            />
        </svg>
    );
};

export default React.memo(Invoice);
